import type { HeroClassDef } from "../../engine/rpg/Hero";

export const CLASSES: HeroClassDef[] = [
  {
    id: "hero",
    name: "Hero",
    appearance: {
      tunic: 0x3f6fd8,
      trim: 0xffd23f,
      pants: 0x2b3a55,
      hair: 0x8a5a2b,
      cape: 0xc23a4a,
      hat: "none",
      sword: true,
      shield: true,
    },
    base: { maxHp: 22, maxMp: 4, attack: 9, defense: 6, agility: 7 },
    growth: { maxHp: 6.5, maxMp: 1.6, attack: 3.1, defense: 2.4, agility: 2.0 },
    learnset: [
      { level: 2, skill: "mend" },
      { level: 5, skill: "spark" },
      { level: 9, skill: "greater-mend" },
    ],
  },
  {
    id: "mage",
    name: "Mage",
    appearance: {
      tunic: 0x6b3fa0,
      trim: 0xd8c9ff,
      pants: 0x3a2450,
      hair: 0xf0e0a0,
      hat: "pointy",
      hatColor: 0x6b3fa0,
      staff: true,
      scale: 0.95,
    },
    base: { maxHp: 15, maxMp: 12, attack: 5, defense: 4, agility: 9 },
    growth: { maxHp: 4.0, maxMp: 4.2, attack: 1.8, defense: 1.7, agility: 2.6 },
    learnset: [
      { level: 1, skill: "spark" },
      { level: 3, skill: "lullaby" },
      { level: 6, skill: "firestorm" },
      { level: 10, skill: "revive" },
    ],
  },
  {
    id: "cleric",
    name: "Cleric",
    appearance: {
      tunic: 0xe8e4d8,
      trim: 0xffd23f,
      pants: 0x9a8a70,
      hair: 0x3b2a1a,
      hat: "hood",
      hatColor: 0xe8e4d8,
      staff: true,
      scale: 0.97,
    },
    base: { maxHp: 19, maxMp: 9, attack: 7, defense: 5, agility: 6 },
    growth: { maxHp: 5.2, maxMp: 3.0, attack: 2.3, defense: 2.1, agility: 1.8 },
    learnset: [
      { level: 1, skill: "mend" },
      { level: 4, skill: "lullaby" },
      { level: 7, skill: "greater-mend" },
      { level: 11, skill: "revive" },
    ],
  },
];
